import React, { useEffect, useRef, useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { commonGetService, handleFilterApi } from "../../../utils/properties";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { showToast } from "../../../features/Toaster/toastslice";
import { activityContext, AccessInfo } from "../../../pages/Dashboard";
import { useNavigate } from "react-router-dom";
import "../../../styles/Dashboard/contributorsList.scss";
import ContributorsCard from "./ContributorsCard";

interface UserInfo {
    image: string,
    email: string,
    department: string,
    designation: string,
    employee_id: number,
    employee_code: string,
    employee_name: string,
    reason: string,
    device_id: string
}
export interface WorkedHours {
    deviceId: string,
    total_time: string,
    total_time_percentage: number,
    idle_time: null | number,
    idle_time_percentage: number,
    user_info: UserInfo
}

const ContributorsList = () => {
    const [isTopLoading, setIsTopLoading] = useState<boolean>(true);
    const [isLeastLoading, setIsLeastLoading] = useState<boolean>(true);
    const [topContributorsList, setTopContributorsList] = useState<WorkedHours[]>([]);
    const [leastContributorsList, setLeastContributorsList] = useState<WorkedHours[]>([]);

    //Details for Roles based UI
    const accessInfo: AccessInfo = useContext(activityContext)?.accessInfo as AccessInfo;

    const filterData = useAppSelector((state) => state.filterData)
    const dispatch = useAppDispatch();
    const Navigate = useNavigate();
    const { startDate, endDate, empDeviceId, filterType, organization, department, employeeIds } = filterData; // Destructuring the filterData state value

    const targetRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.25,
        };

        const observerCallback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (accessInfo["Worked Most Hours"]) {
                        getTopContributorsList();
                    }
                    if (accessInfo["Worked Least Hours"]) {
                        getLeastContributorsList();
                    }

                    observer.disconnect();
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, options);

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [startDate, endDate, empDeviceId, filterType, organization, department, accessInfo]);

    const getTopContributorsList = () => {
        setIsTopLoading(true);
        commonGetService(`/api/1.0/dashboard/work/most/hours?${handleFilterApi(startDate, endDate, filterType, organization, empDeviceId, department, false)}`)
            .then(res => {
                setIsTopLoading(false);
                if (res.status === 200) {
                    setTopContributorsList(res?.data);
                }
                else {
                    dispatch(
                        showToast({
                            message: "Something went wrong in API.",
                            status: "retry",
                            visible: true,
                        })
                    );
                }
            })
    }

    const getLeastContributorsList = () => {
        setIsLeastLoading(true);
        commonGetService(`/api/1.0/dashboard/work/least/hours?${handleFilterApi(startDate, endDate, filterType, organization, empDeviceId, department, false)}`)
            .then(res => {
                setIsLeastLoading(false);
                if (res.status === 200) {
                    setLeastContributorsList(res?.data);
                }
                else {
                    dispatch(
                        showToast({
                            message: "Something went wrong in API.",
                            status: "retry",
                            visible: true,
                        })
                    );
                }
            })
    }

    const handleNavigation = (
        e: React.MouseEvent<Element, MouseEvent>,
        type: string

    ) => {
        e.stopPropagation();
        Navigate(`/reports`, { state: { reportType: type, employeeIds: employeeIds, Alluser: filterData.organization === "All Organizations", startDate: startDate, endDate: endDate } });
    };

    return (
        <div ref={targetRef} >
            <Row className="ctbr-row">
                {accessInfo["Worked Most Hours"] &&
                    <Col className="ctbr-col">
                        <ContributorsCard
                            title='most'
                            isLoading={isTopLoading}
                            navigate={handleNavigation}
                            contributorsList={topContributorsList}
                        />
                    </Col>
                }
                {accessInfo["Worked Least Hours"] &&
                    <Col className="ctbr-col">
                        <ContributorsCard
                            title='least'
                            isLoading={isLeastLoading}
                            navigate={handleNavigation}
                            contributorsList={leastContributorsList}
                        />
                    </Col>
                }
            </Row>
        </div>
    );
};

export default ContributorsList;